export default __webpack_public_path__ + "static/media/iphone_13.2be4ca65.png";